import { useLocation, Outlet } from 'react-router-dom'
import { useEffect } from 'react'
import { assets } from '../config/assets'
import Header from './Header'
import Footer from './Footer'
import Breadcrumbs from './Breadcrumbs'
import { useAuthStore } from '../store/authStore'

export default function Layout() {
  const location = useLocation()
  const isHome = location.pathname === '/'
  const fetchUser = useAuthStore((state) => state.fetchUser)

  // MVP: check the Flask session on every app load / route change.
  useEffect(() => {
    fetchUser()
  }, [fetchUser])

  return (
    <div className={`min-h-screen flex flex-col relative ${isHome ? 'bg-brand-blue' : 'bg-brand-cream'}`}>
      {isHome && (
        <div
          className="absolute inset-0 bg-cover bg-fixed bg-center pointer-events-none"
          style={{ backgroundImage: `url(${assets.backgroundPattern})` }}
          aria-hidden="true"
        />
      )}
      <div className="relative z-10 flex flex-col min-h-screen">
        <Header />
        {!isHome && <Breadcrumbs />}
        <main className={`flex-1 w-full ${isHome ? '' : 'pt-24 pb-16'}`}>
          <Outlet />
        </main>
        {!isHome && <Footer className="fixed bottom-0 left-0 right-0 z-40" />}
      </div>
    </div>
  )
}
